export const INPUT_PADDING = 5;
